import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../Common/Loader.js"; // adjust path if needed
import { apiFetch } from "../../utils/api.js"; // ✅ reuse apiFetch

const ResetPassword = () => {
  const { token } = useParams(); // token from URL
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleReset = async () => {
    if (!newPassword) {
      toast.error("Please enter a new password");
      return;
    }

    setLoading(true);

    try {
      const data = await apiFetch(`/api/auth/reset-password/${token}`, {
        method: "POST",
        body: JSON.stringify({ newPassword }), // ✅ backend expects this
      });

      toast.success(data.message || "Password reset successful");

      // redirect after short delay
      setTimeout(() => {
        navigate("/signin");
      }, 2000);
    } catch (error) {
      console.error(error);
      toast.error(error.message || "Error resetting password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      {loading && <Loader />} {/* 🔵 overlay loader */}
      <div className="auth-content">
        <h2>Reset Password</h2>
        <input
          type="password"
          placeholder="Enter new password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />
        <button
          onClick={handleReset}
          style={{ marginTop: "30px" }}
          disabled={loading}
        >
          {loading ? "Processing..." : "Reset Password"}
        </button>
      </div>
    </div>
  );
};

export default ResetPassword;
